import { ProductDetails } from '@/@types';
import { ContentsResponse, ProductDetailsResponse, SpecificationsResponse } from '../products/models/ProductsDetailsResponse';

export function mapProductDetails(product: ProductDetailsResponse): ProductDetails {

    return {
        name: product.name,
        short_name: product.short_name,
        slug: product.slug,
        resume: product.resume,
        short_description: product.short_description,
        long_description: product.long_description,
        meta_title: product.meta_title,
        meta_description: product.meta_description,
        meta_keywords: product.meta_keywords,
        general_specifications: product.general_specifications,
        characteristics: {
            metric: product.characteristics.metric?.map(mapSpecification),
            english: product.characteristics.english?.map(mapSpecification),
            noType: product.characteristics.no_type?.map(mapSpecification),
        },
        contents: {
            images: product.contents.images?.map(mapContent),
            videos: product.contents.videos?.map(mapContent),
            files: product.contents.files?.map(mapContent),
        },
        usedProduct: product.usedProduct,
        family: product.family,
        subfamily: product.subfamily,
        industry: product.industry,
        brand: product.brand,
    }
}

export function mapSpecification(spec: SpecificationsResponse) {
    return {
        value: spec.value,
        unit: spec.unit ?? '',
        unit_type: spec.unitType ?? '',
        rubro_specification: {
            name: spec.rubro_specification.name,
            rubro: spec.rubro_specification.rubro,
            specification_type: spec.rubro_specification.specification_type,
        },
    };
}

function mapContent(content: ContentsResponse) {
    return {
        title: content.title,
        media_url: content.media_url,
        local: content.local,
    };
}

